import { OnyxScheduleCompliance } from '@onyx/angular';
import type { ScheduleComplianceColor } from '../interfaces/common/schedule-compliance-color';

export class ScheduleComplianceHelper {
  public static getColor(
    compliance: OnyxScheduleCompliance,
  ): ScheduleComplianceColor {
    switch (compliance) {
      case OnyxScheduleCompliance.ON_TIME:
        return 'green';
      case OnyxScheduleCompliance.DELAY_RISK:
        return 'orange';
      case OnyxScheduleCompliance.DELAYED:
        return 'red';
    }
  }
}
